import { useBraze } from '@/components/Braze';
import { useState, useEffect } from 'react';

interface Card {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  linkText: string;
  viewed: boolean;
  url: string;
  extras?: {
    feed_type?: string;
  };
}

export function useBrazeContentCards(feedType: string) {
  const {
    subscribeToContentCardsUpdates,
    removeSubscription,
    logCardDismissal,
    logClickedCard,
    logCardImpressions,
  } = useBraze();
  const [cards, setCards] = useState<Card[]>([]);

  useEffect(() => {
    const unsubscribeId = subscribeToContentCardsUpdates((updates) => {
      setCards(updates.cards);
    });
    return () => {
      removeSubscription(unsubscribeId);
    };
  }, [subscribeToContentCardsUpdates, removeSubscription]);

  const contentCards = cards.filter(
    (card) => card.extras?.feed_type === feedType
  );

  function dismissContentCard(card: Card) {
    logCardDismissal(card);
    const filteredCards = contentCards.filter((item) => item.id !== card.id);
    setCards(filteredCards);
  }

  function clickedContentCard(card: Card) {
    logClickedCard(card);
  }

  function cardImpressions(card: Card[]) {
    logCardImpressions(card);
  }

  return {
    contentCards,
    dismissContentCard,
    clickedContentCard,
    cardImpressions,
  };
}
